import React, { useState } from "react";
import { ContainerTable, TableView } from "../../../components/Table";
import { useApp } from "../../../contexts";
import {
  CellRowValue,
  ContainerTableMobile,
  EqualIcon,
  TextCellTable,
} from "../styles";
import FormButton from "../../../components/FormCustom2/Button";
import { CellRowImage } from "../styles";
import { useNavigate } from "react-router-dom";
import { TYPE_WALLET_DETAIL } from "../../../constants";
import {
  DesktopContainer,
  MobileContainer,
} from "../../../components/Container";
import { RecordNotFound } from "../../../components/RecordNotFound";
import { getCoinCodeImage } from "../../../utils/helper";
import { WalletRowItemGame } from "./WalletRowItemGame";
import useAgeRestriction from "../../../hook/useAgeRestriction";
import ModalUpdateAgeInformation from "../../../components/ModalUpdateAgeInformation";
import ModalAgeIneligible from "../../../components/ModalAgeIneligible";

export const TableGame = ({ data, visible, tab }) => {
  const { T, formatLocalCurrency, formatCurrency, getCurrency, setAlert } = useApp();
  const navigate = useNavigate();

  const [isShowModalUpdateAgeInformation, setIsShowModalUpdateAgeInformation] =
    useState(false);
  const [isShowModalAgeIneligible, setIsShowModalAgeIneligible] =
    useState(false);
  const { checkAge } = useAgeRestriction({
    isAffiliate: true,
    onRequireUpdate: () => {
      setIsShowModalUpdateAgeInformation(true);
      setIsShowModalAgeIneligible(false);
    },
    onEligible: () => {
      setIsShowModalUpdateAgeInformation(false);
      setIsShowModalAgeIneligible(false);
    },
    onIneligible: () => {
      setIsShowModalUpdateAgeInformation(false);
      setIsShowModalAgeIneligible(true);
    },
    onError: (error) => {
      setAlert({ type: "error", text: T('Something went wrong! Please try again later!') });
    },
  });

  const onWithdraw = (record) => {
    navigate(
      `/withdraw-sgt?type=${tab}&walletId=${record?.id}&code=${record.coin}`
    );
  };

  const onConvert = (record) => {
    navigate(`/withdraw?type=${tab}&code=${record.coin}`);
  };
  const columns = [
    {
      title: T(
        tab === TYPE_WALLET_DETAIL.OPTION
          ? "Opportunity token"
          : tab === TYPE_WALLET_DETAIL.CRYPTO
          ? "Coin"
          : "Credit"
      ),
      dataIndex: "coin",
      key: "coin",
      width: 300,
      sorter: (a, b) => a.coin.toString().localeCompare(b.coin),
      render: (text, record, index) => {
        return (
          <CellRowImage style={{ minWidth: 60 }}>
            <img
              alt=""
              style={{ width: 28, height: 28 }}
              src={`/assets/images/otc/crypto/${getCoinCodeImage(
                text
              )?.toLowerCase()}.svg`}
            />
            <span style={{ marginLeft: 4 }}>{text}</span>
          </CellRowImage>
        );
      },
    },
    {
      title: T("Market Price"),
      dataIndex: "marketPrice",
      key: "btcValue",
      align: "right",
      className: "btc-value",
      width: 200,
      sorter: (a, b) => a.marketPrice - b.marketPrice,
      render: (text, record, index) => (
        <TextCellTable>
          {formatLocalCurrency(record.marketPrice)}
        </TextCellTable>
      ),
    },
    {
      title: T("Amount"),
      dataIndex: "amount",
      key: "amount",
      align: "right",
      width: 400,
      render: (text, record, index) => (
        <TextCellTable>
          {formatCurrency(record.amount, 8, getCurrency())}
        </TextCellTable>
      ),
    },
    {
      title: T("BTC Value"),
      dataIndex: "btc",
      key: "btc",
      className: "btc-value",
      align: "right",
      width: 300,
      render: (text, record, index) => {
        return !visible ? (
          "********"
        ) : (
          <CellRowValue>
            <>
              <div className="flex flex-col gap-1 items-end">
                <p className="font-normal text-[12px] lg:text-[16px] text-right">
                  {formatCurrency(text, 8, getCurrency())}
                </p>
                <span
                  style={{
                    gap: 8,
                    fontSize: 16,
                    justifyContent: "flex-end",
                  }}
                >
                  <EqualIcon />
                  {formatLocalCurrency(record.local)}
                </span>
              </div>
            </>
          </CellRowValue>
        );
      },
      sorter: (a, b) => parseFloat(a.btc) - parseFloat(b.btc),
    },
    {
      title: T("Action"),
      dataIndex: "id",
      key: "id",
      align: "center",
      width: 250,
      render: (text, record, index) => (
        <FormButton
          paddingLeft={20}
          paddingRight={20}
          paddingBottom={16}
          width={120}
          paddingTop={16}
          className="primary2"
          onClick={(e) => {
            e.stopPropagation();
            record.coin === "SZT"
              ? checkAge(() => onConvert(record))
              : onWithdraw(record);
          }}
        >
          {T(record.coin === "SZT" ? "Convert" : "Withdraw")}
        </FormButton>
      ),
    },
  ];

  const onDetail = (type, id, record) => {
    if (tab !== TYPE_WALLET_DETAIL.OPTION) {
      if (record.coin === "SGT" && record.type === 5) {
        navigate(`/wallet-detail/gameCurrencySGT?code=${record.coin}`);
      } else if (record.coin === "SZT" && record.type === 1) {
        navigate(
          `/wallet-detail/${TYPE_WALLET_DETAIL.GAMECURRENCY}?code=${record.coin}`
        );
      } else {
        navigate(`/wallet-detail/${type}?walletId=${id}&code=${record.coin}`);
      }
    } else {
      navigate(`/wallet-detail/option/?walletId=${id}&code=${record.coin}`);
    }
  };
  return (
    <div>
      <div className="mt-[10px] lg:mt-[20px]">
        <DesktopContainer>
          <ContainerTable>
            <TableView
              scroll={{ x: true }}
              tableLayout={"fixed"}
              pagination={false}
              dataSource={data}
              columns={columns}
              isClickRow
              onRow={(record, rowIndex) => {
                return {
                  onClick: (event) => {
                    onDetail(tab, record.id, record);
                  },
                };
              }}
            />
          </ContainerTable>
        </DesktopContainer>
        <MobileContainer>
          {data?.length ? (
            <ContainerTableMobile>
              {data?.map((item, index) => (
                <WalletRowItemGame
                  onClick={() => onDetail(tab, item.id, item)}
                  key={item.id}
                  coin={item.coin}
                  onWithdraw={() => onWithdraw(item)}
                  onConvert={() => checkAge(() => onConvert(item))}
                  item={item}
                  marketPrice={item.marketPrice}
                  amount={item.amount}
                  local={item.local}
                />
              ))}
            </ContainerTableMobile>
          ) : (
            <RecordNotFound />
          )}
        </MobileContainer>
      </div>

      {isShowModalAgeIneligible && (
        <ModalAgeIneligible
          title={T("Affiliate Program Restriction")}
          message={T("Age Requirement Not Met")}
          description={T(
            "You're not eligible to perform this transaction."
          )}
          onClose={() => setIsShowModalAgeIneligible(false)}
          onConfirm={() => {
            setIsShowModalAgeIneligible(false);
          }}
        ></ModalAgeIneligible>
      )}
      {isShowModalUpdateAgeInformation && (
        <ModalUpdateAgeInformation
          title={T("Affiliate Program Restriction")}
          message={T("Age Information not found")}
          description={T(
            "Please provide the age information before taking further action."
          )}
          onClose={() => setIsShowModalUpdateAgeInformation(false)}
          onConfirm={() => {
            setIsShowModalUpdateAgeInformation(false);
            navigate("/profile");
          }}
        ></ModalUpdateAgeInformation>
      )}
    </div>
  );
};
